// @flow

import React, { useRef, useCallback, type Node, type ElementProps, type Ref } from 'react';

import { useInputMask } from './use-input-mask';
import { type Mask } from './types';

type Props = {
  +mask: Mask,
  +value?: ?string,
  +onChange?: (SyntheticInputEvent<HTMLInputElement>) => void,
};

function InputMaskInternal(
  { mask, value, onChange, ...props }: Props,
  ref: Ref<'input'>,
): Node {
  const ownInputRef = useRef();
  const inputRef: any = ref || ownInputRef;
  const updateValueForMask = useInputMask(inputRef, mask, value);

  const handleChange = useCallback(
    (event: SyntheticInputEvent<HTMLInputElement>) => {
      updateValueForMask();
      if (onChange) {
        onChange(event);
      }
    },
    [onChange, updateValueForMask],
  );

  return <input {...props} ref={inputRef} value={value} onChange={handleChange} />;
}

export const InputMask = React.forwardRef<ElementProps<typeof InputMaskInternal>, HTMLInputElement>(InputMaskInternal);
